import { useState } from 'react';

const useDarkMode = () => {
    const [componentMounted] = useState(true);
    const [disableScroll, setDisableScroll] = useState(false);

    const toggleMode = () => {};

    return ['light', toggleMode, '', componentMounted, disableScroll];
};

export { useDarkMode };
